/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Phone_Is_WhatsappInputs */



/**
* | output |
* | --- |
* | "This is a WhatsApp number" |
*
* @param {Profile_Phone_Is_WhatsappInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_phone_is_whatsapp = /** @type {((inputs?: Profile_Phone_Is_WhatsappInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Phone_Is_WhatsappInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("C'est un numéro WhatsApp")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este es un número de WhatsApp")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este é um número do WhatsApp")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo è un numero WhatsApp")
	return /** @type {LocalizedString} */ ("This is a WhatsApp number")
});